import React from 'react'
import { C, F, DEPTS } from './theme'
import { formatGBP } from '../../lib/money'

// Shared Forecast Studio primitives (handoff doc 02 §2.4). Every forecast
// screen composes these. Money helpers work in integer PENCE (repo convention)
// and format at the edge via lib/money.ts.

export const gbp = (pence: number): string => formatGBP(Math.round(pence))

// ---- Icon (self-contained; prototype ICONS paths, currentColor stroke) ----
const ICONS: Record<string, string> = {
  home: 'M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z|M9 22V12h6v10',
  calendar: 'M19 4H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z|M16 2v4|M8 2v4|M3 10h18',
  list: 'M21 12h-8|M21 6h-8|M21 18h-8|M3 6v4c0 1.1.9 2 2 2h3|M3 10v6c0 1.1.9 2 2 2h3',
  users: 'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2|M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z|M22 21v-2a4 4 0 0 0-3-3.87|M16 3.13a4 4 0 0 1 0 7.75',
  box: 'M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z|M3.27 6.96 12 12.01l8.73-5.05|M12 22.08V12',
  chart: 'M3 3v18h18|M18 17V9|M13 17V5|M8 17v-3',
  shield: 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z|M9 12l2 2 4-4',
  plus: 'M12 5v14|M5 12h14',
  search: 'M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16z|M21 21l-4.35-4.35',
  bell: 'M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9|M10.3 21a1.94 1.94 0 0 0 3.4 0',
  check: 'M20 6 9 17l-5-5',
  checkc: 'M22 11.08V12a10 10 0 1 1-5.93-9.14|M22 4 12 14.01l-3-3',
  alert: 'M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z|M12 9v4|M12 17h.01',
  download: 'M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4|M7 10l5 5 5-5|M12 15V3',
  edit: 'M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7|M18.5 2.5a2.121 2.121 0 1 1 3 3L12 15l-4 1 1-4 9.5-9.5z',
  x: 'M18 6 6 18|M6 6l12 12',
  chevR: 'M9 18l6-6-6-6', chevD: 'M6 9l6 6 6-6', chevL: 'M15 18l-6-6 6-6',
  clock: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z|M12 6v6l4 2',
  flag: 'M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z|M4 22V15',
  info: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z|M12 16v-4|M12 8h.01',
  grid: 'M3 3h7v7H3z|M14 3h7v7h-7z|M14 14h7v7h-7z|M3 14h7v7H3z',
  train: 'M8 3h8a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z|M9 7h6|M9 11h6|M9 17l-2 4|M15 17l2 4|M5 17h14',
  pound: 'M18 7c0-5.333-8-5.333-8 0|M10 7v14|M6 21h12|M6 13h10',
  ticket: 'M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2z|M13 5v2|M13 17v2|M13 11v2',
  activity: 'M22 12h-4l-3 9L9 3l-3 9H2',
  target: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z|M12 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12z|M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4z',
  star: 'M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z',
  book: 'M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z|M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z',
  msg: 'M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z',
  lock: 'M5 11h14a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2z|M7 11V7a5 5 0 0 1 10 0v4',
  eye: 'M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z|M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
  coffee: 'M17 8h1a4 4 0 1 1 0 8h-1|M3 8h14v9a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4z|M6 2v3|M10 2v3|M14 2v3',
  refresh: 'M23 4v6h-6|M1 20v-6h6|M3.51 9a9 9 0 0 1 14.85-3.36L23 10|M1 14l4.64 4.36A9 9 0 0 0 20.49 15',
  send: 'M22 2 11 13|M22 2l-7 20-4-9-9-4z',
  sparkle: 'M12 3l1.9 5.8L20 11l-6.1 2.2L12 19l-1.9-5.8L4 11l6.1-2.2z',
  link: 'M10 13a5 5 0 0 0 7 0l3-3a5 5 0 0 0-7-7l-1 1|M14 11a5 5 0 0 0-7 0l-3 3a5 5 0 0 0 7 7l1-1',
  trend: 'M23 6l-9.5 9.5-5-5L1 18|M17 6h6v6',
  bolt: 'M13 2 4 14h7l-1 8 9-12h-7l1-8z',
  globe: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z|M2 12h20|M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z',
  layers: 'M12 2 2 7l10 5 10-5-10-5z|M2 17l10 5 10-5|M2 12l10 5 10-5',
  gauge: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z|M12 12l4-4',
  wrench: 'M14.7 6.3a4 4 0 0 0-5.4 5.4L3 18l3 3 6.3-6.3a4 4 0 0 0 5.4-5.4l-2.6 2.6-2.4-2.4z',
  cloud: 'M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z',
  file: 'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z|M14 2v6h6|M16 13H8|M16 17H8',
  megaphone: 'M3 11v2a1 1 0 0 0 1 1h2l5 4V6L6 10H4a1 1 0 0 0-1 1z|M15 8a4 4 0 0 1 0 8'
}

export function Icon({ name, size = 16, color }: { name: string; size?: number; color?: string }) {
  const d = ICONS[name] || ICONS.box!
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color ?? 'currentColor'}
      strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0, display: 'block' }}>
      {d.split('|').map((p, i) => <path key={i} d={p} />)}
    </svg>
  )
}

// ---- Card ----
export function Card({ children, style, pad = 18 }: { children: React.ReactNode; style?: React.CSSProperties; pad?: number }) {
  return (
    <div style={{ background: C.card, borderRadius: 12, border: `1px solid ${C.lineSoft}`, boxShadow: '0 1px 2px rgba(20,50,42,0.04)', padding: pad, ...style }}>
      {children}
    </div>
  )
}

export function SectionHead({ icon, label, right }: { icon: string; label: string; right?: React.ReactNode }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 9, marginBottom: 14 }}>
      <span style={{ width: 28, height: 28, borderRadius: 8, background: C.greenBg, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Icon name={icon} size={15} color={C.green} />
      </span>
      <span style={{ fontFamily: F.body, fontSize: 11, fontWeight: 800, letterSpacing: 1, textTransform: 'uppercase', color: C.inkSoft }}>{label}</span>
      {right && <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 8 }}>{right}</div>}
    </div>
  )
}

export function Pill({ children, fg = C.brassDk, bg = C.brassBg, icon }: { children: React.ReactNode; fg?: string; bg?: string; icon?: string }) {
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5, padding: '3px 10px', borderRadius: 999, background: bg, color: fg, fontFamily: F.body, fontSize: 11.5, fontWeight: 800, border: `1px solid ${fg}22`, whiteSpace: 'nowrap' }}>
      {icon && <Icon name={icon} size={12} />}{children}
    </span>
  )
}

type Variant = 'primary' | 'brass' | 'secondary' | 'soft' | 'danger' | 'ghost'
export function Btn({ children, variant = 'primary', onClick, icon, small, disabled, type }: { children: React.ReactNode; variant?: Variant; onClick?: () => void; icon?: string; small?: boolean; disabled?: boolean; type?: 'button' | 'submit' }) {
  const base: React.CSSProperties = { display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 7, fontFamily: F.body, fontWeight: 800, fontSize: small ? 12 : 13.5, padding: small ? '6px 11px' : '9px 15px', borderRadius: 9, cursor: disabled ? 'default' : 'pointer', border: 'none', letterSpacing: 0.2, whiteSpace: 'nowrap', opacity: disabled ? 0.5 : 1 }
  const V: Record<Variant, React.CSSProperties> = {
    primary: { background: C.green, color: '#fff', boxShadow: '0 2px 6px rgba(10,74,58,0.22)' },
    brass: { background: C.brass, color: '#fff', boxShadow: '0 2px 6px rgba(155,127,42,0.22)' },
    secondary: { background: C.card, color: C.green, border: `1px solid ${C.line}` },
    soft: { background: C.greenBg, color: C.green, border: `1px solid ${C.greenSoft}` },
    danger: { background: C.oxbloodSoft, color: C.oxblood, border: `1px solid ${C.oxblood}44` },
    ghost: { background: 'transparent', color: C.inkSoft }
  }
  return (
    <button type={type ?? 'button'} onClick={disabled ? undefined : onClick} disabled={disabled} style={{ ...base, ...V[variant] }}>
      {icon && <Icon name={icon} size={small ? 13 : 15} />}{children}
    </button>
  )
}

export function DeptChip({ id, small }: { id: string; small?: boolean }) {
  const d = DEPTS[id]; if (!d) return null
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5, padding: small ? '2px 8px' : '3px 10px', borderRadius: 999, background: d.bg, color: d.fg, fontFamily: F.body, fontSize: small ? 10 : 11, fontWeight: 800, whiteSpace: 'nowrap' }}>
      <span style={{ width: 6, height: 6, borderRadius: 3, background: d.fg }} />{d.short}
    </span>
  )
}

export function Avatar({ name, size = 30 }: { name: string; size?: number }) {
  const init = (name || '?').split(' ').map((w) => w[0]).join('').slice(0, 2).toUpperCase()
  return (
    <div style={{ width: size, height: size, borderRadius: size / 3, background: C.greenBg, color: C.green, display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: F.serif, fontWeight: 700, fontSize: size * 0.4, flexShrink: 0, border: `1px solid ${C.greenSoft}` }}>{init}</div>
  )
}

export function Bar({ pct, color, h = 8 }: { pct: number; color: string; h?: number }) {
  return (
    <div style={{ height: h, borderRadius: 999, background: C.lineSoft, overflow: 'hidden' }}>
      <div style={{ width: `${Math.max(1, Math.min(100, pct))}%`, height: '100%', background: color, borderRadius: 999 }} />
    </div>
  )
}

export function Head({ eyebrow, title, sub, right }: { eyebrow: string; title: string; sub?: React.ReactNode; right?: React.ReactNode }) {
  return (
    <div style={{ display: 'flex', alignItems: 'flex-start', gap: 16, marginBottom: 20, flexWrap: 'wrap' }}>
      <div style={{ flex: 1, minWidth: 330 }}>
        <div style={{ fontFamily: F.body, fontSize: 11, fontWeight: 800, letterSpacing: 1.2, textTransform: 'uppercase', color: C.brass }}>{eyebrow}</div>
        <h1 style={{ fontFamily: F.serif, fontSize: 30, fontWeight: 800, color: C.ink, margin: '4px 0 0', letterSpacing: -0.4, lineHeight: 1.05 }}>{title}</h1>
        {sub && <div style={{ fontFamily: F.body, fontSize: 13.5, color: C.inkSoft, marginTop: 6 }}>{sub}</div>}
      </div>
      {right && <div style={{ flexShrink: 0 }}>{right}</div>}
    </div>
  )
}

// Locked-card for financial gating (belt-and-braces with the server 403).
export function LockedCard({ label = 'Financial access required' }: { label?: string }) {
  return (
    <Card style={{ textAlign: 'center', padding: 28 }}>
      <div style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 42, height: 42, borderRadius: 12, background: C.brassBg, marginBottom: 10 }}>
        <Icon name="lock" size={20} color={C.brass} />
      </div>
      <div style={{ fontFamily: F.body, fontSize: 13, fontWeight: 700, color: C.inkSoft }}>{label}</div>
    </Card>
  )
}
